"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _dom = require("../utils/dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Box = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    as,
    w,
    h,
    minW,
    minH,
    maxW,
    maxH,
    p,
    m,
    bg,
    border,
    rounded,
    shadow,
    text,
    font,
    focus,
    hover,
    selected,
    children,
    className,
    style = {},
    ...props
  } = _ref;
  const Component = as || "div";
  const width = (0, _dom.toCSSProps)(w, "width");
  const height = (0, _dom.toCSSProps)(h, "height");
  const minWidth = (0, _dom.toCSSProps)(minW, "minWidth");
  const minHeight = (0, _dom.toCSSProps)(minH, "minHeight");
  const maxWidth = (0, _dom.toCSSProps)(maxW, "maxWidth");
  const maxHeight = (0, _dom.toCSSProps)(maxH, "maxHeight");
  const padding = (0, _dom.toCSSProps)(p, "padding");
  const margin = (0, _dom.toCSSProps)(m, "margin");
  return /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
    className: (0, _classnames.default)(width === undefined ? w : "", height === undefined ? h : "", minWidth === undefined ? minW : "", maxWidth === undefined ? maxW : "", minHeight === undefined ? minH : "", maxHeight === undefined ? maxH : "", padding === undefined ? p : "", margin === undefined ? m : "", bg, border, rounded, shadow, text, font, focus, hover, selected, className),
    style: {
      ...style,
      ...width,
      ...height,
      ...minWidth,
      ...minHeight,
      ...maxWidth,
      ...maxHeight,
      ...padding,
      ...margin
    },
    ref: ref
  }), children);
});
exports.Box = Box;
Box.displayName = "Box";